import { buildProps, definePropType, isBoolean, isNumber } from '@bigin/utils'
import { CHANGE_EVENT } from '@bigin/constants'
import type { ExtractPropTypes } from 'vue'
import type { Property } from 'csstype'
import type Affix from './affix.vue'

export const affixProps = buildProps({
  zIndex: {
    type: definePropType<Property.ZIndex>([Number, String]),
    default: 100,
  },
  target: {
    type: String,
    default: '',
  },
  offset: {
    type: Number,
    default: 0,
  },
  position: {
    type: String,
    values: ['top', 'bottom'],
    default: 'top',
  },
} as const)
export type AffixProps = ExtractPropTypes<typeof affixProps>

export const affixEmits = {
  scroll: ({ scrollTop, fixed }: { scrollTop: number; fixed: boolean }) =>
    isNumber(scrollTop) && isBoolean(fixed),
  [CHANGE_EVENT]: (fixed: boolean) => isBoolean(fixed),
}
export type AffixEmits = typeof affixEmits

export type AffixInstance = InstanceType<typeof Affix>
